<template>
    <a
        class="tw-aspect-square tw-max-h-[420px] tw-cursor-pointer"
        :href="event.url"
        target="_blank">
        <div
            class="tw-flex tw-aspect-square tw-max-h-[420px] tw-flex-col tw-justify-end tw-overflow-hidden tw-rounded-2xl tw-bg-cover tw-bg-center tw-bg-no-repeat"
            :style="{ backgroundImage: `url(${useMedia(event.image).medium})` }">
            <div class="tw-m-6 tw-grid tw-grid-cols-12 tw-items-center tw-justify-center tw-rounded-2xl tw-bg-white tw-bg-opacity-90 tw-px-3 tw-text-dark">
                <div class="tw-col-span-4 tw-my-6 tw-flex tw-flex-col tw-items-center tw-justify-center tw-border-r tw-border-gray-800">
                    <span class="tw-text-3xl tw-font-semibold">{{ day }}</span>
                    <span class="tw-text-xl tw-font-semibold tw-uppercase">{{ month }}</span>
                </div>
                <div class="tw-col-span-8 tw-my-6 tw-flex tw-flex-col tw-justify-center tw-pl-4">
                    <h3 class="tw-text-lg tw-font-semibold">{{ event.name }}</h3>
                    <p>{{ event.location }}</p>
                </div>
            </div>
        </div>
    </a>
</template>

<script setup lang="ts">
    import { useMedia } from '@/composables/useMedia';
    import moment from 'moment';

    const props = defineProps<{
        event: any;
    }>();

    const day = computed(() => {
        return moment(props.event.date).format('DD');
    });

    const month = computed(() => {
        return moment(props.event.date).format('MMM');
    });
</script>

<style scoped></style>
